/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { FC, useState } from 'react';
import clsx from 'clsx';
import TextField, { TextFieldProps } from '../TextField';

import Button from '../../Button';
import Icons from '../../SvgLib/icons';
import styles from './passwordField.module.sass';

export interface PasswordFieldProps extends Omit<TextFieldProps, 'rootClassName' | 'type'> {
  rootClassName?: string;
  hidePasswordByDefault?: boolean;
}

const PasswordField: FC<PasswordFieldProps> = props => {
  const { rootClassName, hidePasswordByDefault, ...restProps } = props;
  const [isPasswordField, setIsPasswordField] = useState(hidePasswordByDefault ?? false);
  return (
    <div className={clsx(styles.passwordFieldRoot, rootClassName)}>
      <TextField
        type={isPasswordField ? 'password' : 'text'}
        {...restProps}
        placeHolderColorBlack
      />
      <Button
        ariaLabel={isPasswordField ? 'Hide password' : 'Show password'}
        onlyText
        eventLink
        classes={styles.eyeContainer}
        onClick={() => setIsPasswordField(p => !p)}
      >
        {isPasswordField ? Icons({}).eye_crossed : Icons({}).eye_opened}
      </Button>
    </div>
  );
};

export default PasswordField;
